// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Download.css */
.Download {
    padding: 1px 50px;
    background-color: #303030; /* Reverted to original dark background */
    min-height: 100vh;
    margin-top: 80px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.Download h1 {
    color: white; /* Reverted to original white text */
    font-size: 1.5rem;
    text-align: center;
    margin: 40px 250px;
    font-family: 'GlitchGoblin', sans-serif;
}

.category-bar {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 2rem;
    animation: fadeIn 0.5s ease-in-out forwards;
}

.category-button {
    padding: 10px 20px;
    background-color: #424242; /* Reverted to original dark background */
    color: white; /* Reverted to original white text */
    border: 2px solid #007bff;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.category-button.active,
.category-button:hover {
    background-color: #007bff;
}

.download-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    margin: auto;
}

/* --- MODIFIED: Added min-height for uniform cards --- */
.download-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc((100% - 0px) / 6);
    max-width: 160px;
    /* ⭐️ FIXED CARD HEIGHT (adjust as needed based on your content) ⭐️ */
    min-height: auto; 
    background-color: white; /* Changed to white background */
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    animation: fadeIn 0.5s ease forwards;
    opacity: 0;
}
/* ---------------------------------------------------- */

.image-wrapper {
    aspect-ratio: 1 / 1;
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
}

.download-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 16px;
}

/* --- MODIFIED: Added flex properties to push the button to the bottom --- */
.download-details {
    padding: 5px;
    color: #333; /* Changed to a dark text color for visibility */
    text-align: center;
    display: flex;
    flex-direction: column;
    flex-grow: 1; /* Allows it to occupy available space */
}
/* ---------------------------------------------------- */

.download-details h2 {
    font-size: 0.85rem;
    margin-bottom: 5px;
    margin-top: 5px;
    color: #007bff;
}

/* --- MODIFIED: Renamed version paragraph class for clarity (optional) --- */
.download-version { /* Use the class you created for version p: <p className="download-version"> */
    font-size: 0.75rem;
    margin: 5px 0px;
    color: #828383;
}
/* ---------------------------------------------------- */


/* --- ADDED: Description Container and Toggle Styles --- */
.description-container {
    flex-grow: 1; /* Allows the description area to take up remaining vertical space */
    margin-bottom: 5px;
    position: relative; /* For proper positioning if you use absolute tricks */
    display: flex; /* Helps ensure text and button are aligned */
    flex-direction: column;
    align-items: center;
}

.download-description {
    font-size: 0.8rem; /* Smaller font to fit more text */
    color: #555;
    line-height: 1.3;
    text-align: center;
    /* Optional: Limit the initial visible area for the truncated text */
     /*max-height: 4em;  */
    overflow: hidden;
    margin: 5px 5px;
    justify-items: center;
}

.toggle-description-button {
    background: none;
    border: none;
    color: #1890ff; /* Use your hover color for visibility */
    cursor: pointer;
    padding: 0;
    font-size: 0.7rem; /* Keep it small */
    text-align: center;
    margin-top: 5px;
    white-space: nowrap; /* Prevent button text from wrapping */
}

.toggle-description-button:hover {
    text-decoration: underline;
}
/* ---------------------------------------------------- */


/* --- MODIFIED: Ensure button is pushed to the bottom --- */
.download-button {
    display: inline-block;
    padding: 8px 30px;
    background-color: #007bff;
    color: white;
    border-radius: 8px;
    text-decoration: none;
    margin: 5px 0px; /* ⭐️ Pushes the button to the bottom ⭐️ */
    align-self: center; /* Centers the button horizontally */
}
/* ---------------------------------------------------- */


.download-button:hover {
    background-color: #6db2fd;
}

.see-more-wrapper {
    text-align: center;
    margin-top: 1rem;
}

.see-more-button {
    padding: 8px 16px;
    background-color: #007bff;
    color: white;
    font-size: 0.9rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.see-more-button:hover {
    background-color: #ff4500;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* --- Mobile Media Queries --- */
@media (max-width: 768px) {
    .Download {
        padding: 20px 10px;
    }
    
    .Download h1 {
        margin: 0px 0px;
        font-size: 23px;
    }

    .download-card {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc((100% - 24px) / 2);
        max-width: none;
        /* Adjust fixed height for mobile, possibly shorter */
        min-height: 350px; 
    }
    
    .download-list {
        gap: 22px;
        width: 95%;
    }

    /* Adjust font sizes to fit better on mobile card */
    .download-details h2 {
        font-size: 1rem; /* Adjusting h2 for mobile */
    }

    .download-version, .download-description {
        font-size: 1rem; /* Adjusting paragraph text for mobile */
    }

    .toggle-description-button {
        font-size: 0.8rem;
    }

    .download-button {
        width: 90%;
        height: auto; /* Changed from 20% */
        padding: 10px;
    }
}

/* ============================================================================= */
/* 🛑 SUNTIKAN KOD BARU: KHUSUS UNTUK INFRAME MODAL OVERLAY SAHAJA 🛑            */
/* ============================================================================= */

/* Lapisan latar belakang gelap modal */
.download-focus-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    padding: 15px;
    box-sizing: border-box;
}

/* Kotak Inframe Utama */
.download-focus-inframe {
    background: #3e3e3e;
    color: #ffffff;
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 12px;
    padding: 30px;
    position: relative;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.5);
    animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    box-sizing: border-box;
}

/* Butang Pangkah (Close Button) */
.close-focus-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    background: none;
    border: none;
    color: #aaa;
    font-size: 32px;
    cursor: pointer;
    transition: color 0.2s;
    z-index: 10;
}

.close-focus-btn:hover {
    color: #fff;
}

/* Struktur layout dalam modal (Desktop: Bersebelahan) */
.focus-content-layout {
    display: flex;
    gap: 30px;
    margin-top: 15px;
}

/* Gambar Aplikasi (Kiri) */
.focus-image-section {
    flex: 0 0 40%;
    max-width: 40%;
}

.focus-image-section img {
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
    max-height: 300px;
}

/* Maklumat Aplikasi (Kanan) */
.focus-details-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.focus-details-section h2 {
    text-align: left;
    color: #007bff;
    margin: 0 0 5px 0;
    font-size: 1.5rem;
}

.focus-version-tag {
    font-size: 13px;
    color: #a0a0a0;
    margin: 0 0 15px 0;
    text-align: left;
}

.focus-full-description {
    font-size: 14px;
    color: #ccc;
    line-height: 1.6;
    margin-bottom: 20px;
    text-align: left;
}

/* Kotak putih bahagian butang bawah */
.focus-action-box {
    background: #ffffff;
    padding: 15px;
    border-radius: 8px;
    color: #333;
    margin-top: auto;
}

.focus-download-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.device-badge {
    font-size: 14px;
    color: #555;
    font-weight: 500;
}

.device-badge span {
    color: #007bff;
    font-weight: bold;
}

/* Butang Muat Turun Utama Dalam Modal */
.focus-action-download-btn {
    display: inline-block;
    background: #007bff;
    color: #ffffff;
    text-decoration: none;
    padding: 10px 24px;
    font-weight: bold;
    border-radius: 6px;
    text-align: center;
    transition: background-color 0.2s;
}

.focus-action-download-btn:hover {
    background-color: #6db2fd; /* Guna tema oren asal hover kau */
}

/* 📱 Responsive Inframe Modal Khusus Skrin Mobile 📱 */
@media (max-width: 768px) {
    .download-focus-inframe {
        width: 100%;
        padding: 20px;
        margin: 10px;
    }

    /* Tukar susunan kiri-kanan kepada atas-bawah */
    .focus-content-layout {
        flex-direction: column;
        gap: 15px;
    }

    /* Gambar naik atas dan duduk tengah */
    .focus-image-section {
        max-width: 100%;
        text-align: center;
        margin: 0 auto;
    }

    .focus-image-section img {
        max-height: 180px;
        width: auto;
        max-width: 100%;
    }

    /* Ratakan teks ke tengah supaya kemas kat fon */
    .focus-details-section h2 {
        font-size: 1.2rem;
        text-align: center;
    }

    .focus-version-tag {
        text-align: center;
        margin-bottom: 10px;
    }

    .focus-full-description {
        font-size: 13px;
        text-align: center;
        margin-bottom: 15px;
    }
    
    /* Bar aksi bertukar menegak */
    .focus-download-row {
        flex-direction: column;
        gap: 12px;
        text-align: center;
    }
    
    /* Butang download lebar penuh */
    .focus-action-download-btn {
        width: 100%;
        box-sizing: border-box;
    }
}

/* Animasi khusus naik modal (Tak bertembung dengan fadeIn asal) */
@keyframes modalSlideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/Download.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,yBAAyB,EAAE,yCAAyC;IACpE,iBAAiB;IACjB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,YAAY,EAAE,oCAAoC;IAClD,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,yBAAyB,EAAE,yCAAyC;IACpE,YAAY,EAAE,oCAAoC;IAClD,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA,yDAAyD;AACzD;IACI,YAAgC;IAAhC,cAAgC;IAAhC,kCAAgC;IAChC,gBAAgB;IAChB,qEAAqE;IACrE,gBAAgB;IAChB,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,UAAU;AACd;AACA,yDAAyD;;AAEzD;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,6EAA6E;AAC7E;IACI,YAAY;IACZ,WAAW,EAAE,gDAAgD;IAC7D,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY,EAAE,wCAAwC;AAC1D;AACA,yDAAyD;;AAEzD;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA,6EAA6E;AAC7E,oBAAoB,8EAA8E;IAC9F,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA,yDAAyD;;;AAGzD,2DAA2D;AAC3D;IACI,YAAY,EAAE,oEAAoE;IAClF,kBAAkB;IAClB,kBAAkB,EAAE,sDAAsD;IAC1E,aAAa,EAAE,6CAA6C;IAC5D,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,EAAE,kCAAkC;IACrD,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oEAAoE;KACnE,qBAAqB;IACtB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc,EAAE,wCAAwC;IACxD,eAAe;IACf,UAAU;IACV,iBAAiB,EAAE,kBAAkB;IACrC,kBAAkB;IAClB,eAAe;IACf,mBAAmB,EAAE,sCAAsC;AAC/D;;AAEA;IACI,0BAA0B;AAC9B;AACA,yDAAyD;;;AAGzD,4DAA4D;AAC5D;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe,EAAE,0CAA0C;IAC3D,kBAAkB,EAAE,oCAAoC;AAC5D;AACA,yDAAyD;;;AAGzD;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,iCAAiC;AACjC;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAiC;QAAjC,cAAiC;QAAjC,mCAAiC;QACjC,eAAe;QACf,qDAAqD;QACrD,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA,mDAAmD;IACnD;QACI,eAAe,EAAE,4BAA4B;IACjD;;IAEA;QACI,eAAe,EAAE,wCAAwC;IAC7D;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,YAAY,EAAE,qBAAqB;QACnC,aAAa;IACjB;AACJ;;AAEA,kFAAkF;AAClF,kFAAkF;AAClF,kFAAkF;;AAElF,uCAAuC;AACvC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,4CAA4C;IAC5C,mEAAmE;IACnE,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB,EAAE,kCAAkC;AACjE;;AAEA,uDAAuD;AACvD;IACI;QACI,WAAW;QACX,aAAa;QACb,YAAY;IAChB;;IAEA,+CAA+C;IAC/C;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA,sCAAsC;IACtC;QACI,eAAe;QACf,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,eAAe;IACnB;;IAEA,gDAAgD;IAChD;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,8BAA8B;IAC9B;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;;IAEA,gCAAgC;IAChC;QACI,WAAW;QACX,sBAAsB;IAC1B;AACJ;;AAEA,kEAAkE;AAClE;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC/C","sourcesContent":["/* Download.css */\n.Download {\n    padding: 1px 50px;\n    background-color: #303030; /* Reverted to original dark background */\n    min-height: 100vh;\n    margin-top: 80px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.Download h1 {\n    color: white; /* Reverted to original white text */\n    font-size: 1.5rem;\n    text-align: center;\n    margin: 40px 250px;\n    font-family: 'GlitchGoblin', sans-serif;\n}\n\n.category-bar {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 2rem;\n    animation: fadeIn 0.5s ease-in-out forwards;\n}\n\n.category-button {\n    padding: 10px 20px;\n    background-color: #424242; /* Reverted to original dark background */\n    color: white; /* Reverted to original white text */\n    border: 2px solid #007bff;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.category-button.active,\n.category-button:hover {\n    background-color: #007bff;\n}\n\n.download-list {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 24px;\n    margin: auto;\n}\n\n/* --- MODIFIED: Added min-height for uniform cards --- */\n.download-card {\n    flex: 0 0 calc((100% - 0px) / 6);\n    max-width: 160px;\n    /* ⭐️ FIXED CARD HEIGHT (adjust as needed based on your content) ⭐️ */\n    min-height: auto; \n    background-color: white; /* Changed to white background */\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    animation: fadeIn 0.5s ease forwards;\n    opacity: 0;\n}\n/* ---------------------------------------------------- */\n\n.image-wrapper {\n    aspect-ratio: 1 / 1;\n    width: 100%;\n    padding: 15px;\n    box-sizing: border-box;\n}\n\n.download-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 16px;\n}\n\n/* --- MODIFIED: Added flex properties to push the button to the bottom --- */\n.download-details {\n    padding: 5px;\n    color: #333; /* Changed to a dark text color for visibility */\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1; /* Allows it to occupy available space */\n}\n/* ---------------------------------------------------- */\n\n.download-details h2 {\n    font-size: 0.85rem;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    color: #007bff;\n}\n\n/* --- MODIFIED: Renamed version paragraph class for clarity (optional) --- */\n.download-version { /* Use the class you created for version p: <p className=\"download-version\"> */\n    font-size: 0.75rem;\n    margin: 5px 0px;\n    color: #828383;\n}\n/* ---------------------------------------------------- */\n\n\n/* --- ADDED: Description Container and Toggle Styles --- */\n.description-container {\n    flex-grow: 1; /* Allows the description area to take up remaining vertical space */\n    margin-bottom: 5px;\n    position: relative; /* For proper positioning if you use absolute tricks */\n    display: flex; /* Helps ensure text and button are aligned */\n    flex-direction: column;\n    align-items: center;\n}\n\n.download-description {\n    font-size: 0.8rem; /* Smaller font to fit more text */\n    color: #555;\n    line-height: 1.3;\n    text-align: center;\n    /* Optional: Limit the initial visible area for the truncated text */\n     /*max-height: 4em;  */\n    overflow: hidden;\n    margin: 5px 5px;\n    justify-items: center;\n}\n\n.toggle-description-button {\n    background: none;\n    border: none;\n    color: #1890ff; /* Use your hover color for visibility */\n    cursor: pointer;\n    padding: 0;\n    font-size: 0.7rem; /* Keep it small */\n    text-align: center;\n    margin-top: 5px;\n    white-space: nowrap; /* Prevent button text from wrapping */\n}\n\n.toggle-description-button:hover {\n    text-decoration: underline;\n}\n/* ---------------------------------------------------- */\n\n\n/* --- MODIFIED: Ensure button is pushed to the bottom --- */\n.download-button {\n    display: inline-block;\n    padding: 8px 30px;\n    background-color: #007bff;\n    color: white;\n    border-radius: 8px;\n    text-decoration: none;\n    margin: 5px 0px; /* ⭐️ Pushes the button to the bottom ⭐️ */\n    align-self: center; /* Centers the button horizontally */\n}\n/* ---------------------------------------------------- */\n\n\n.download-button:hover {\n    background-color: #6db2fd;\n}\n\n.see-more-wrapper {\n    text-align: center;\n    margin-top: 1rem;\n}\n\n.see-more-button {\n    padding: 8px 16px;\n    background-color: #007bff;\n    color: white;\n    font-size: 0.9rem;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.see-more-button:hover {\n    background-color: #ff4500;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* --- Mobile Media Queries --- */\n@media (max-width: 768px) {\n    .Download {\n        padding: 20px 10px;\n    }\n    \n    .Download h1 {\n        margin: 0px 0px;\n        font-size: 23px;\n    }\n\n    .download-card {\n        flex: 0 0 calc((100% - 24px) / 2);\n        max-width: none;\n        /* Adjust fixed height for mobile, possibly shorter */\n        min-height: 350px; \n    }\n    \n    .download-list {\n        gap: 22px;\n        width: 95%;\n    }\n\n    /* Adjust font sizes to fit better on mobile card */\n    .download-details h2 {\n        font-size: 1rem; /* Adjusting h2 for mobile */\n    }\n\n    .download-version, .download-description {\n        font-size: 1rem; /* Adjusting paragraph text for mobile */\n    }\n\n    .toggle-description-button {\n        font-size: 0.8rem;\n    }\n\n    .download-button {\n        width: 90%;\n        height: auto; /* Changed from 20% */\n        padding: 10px;\n    }\n}\n\n/* ============================================================================= */\n/* 🛑 SUNTIKAN KOD BARU: KHUSUS UNTUK INFRAME MODAL OVERLAY SAHAJA 🛑            */\n/* ============================================================================= */\n\n/* Lapisan latar belakang gelap modal */\n.download-focus-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.75);\n    backdrop-filter: blur(5px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n    padding: 15px;\n    box-sizing: border-box;\n}\n\n/* Kotak Inframe Utama */\n.download-focus-inframe {\n    background: #3e3e3e;\n    color: #ffffff;\n    width: 100%;\n    max-width: 800px;\n    max-height: 90vh;\n    overflow-y: auto;\n    border-radius: 12px;\n    padding: 30px;\n    position: relative;\n    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.5);\n    animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    box-sizing: border-box;\n}\n\n/* Butang Pangkah (Close Button) */\n.close-focus-btn {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    background: none;\n    border: none;\n    color: #aaa;\n    font-size: 32px;\n    cursor: pointer;\n    transition: color 0.2s;\n    z-index: 10;\n}\n\n.close-focus-btn:hover {\n    color: #fff;\n}\n\n/* Struktur layout dalam modal (Desktop: Bersebelahan) */\n.focus-content-layout {\n    display: flex;\n    gap: 30px;\n    margin-top: 15px;\n}\n\n/* Gambar Aplikasi (Kiri) */\n.focus-image-section {\n    flex: 0 0 40%;\n    max-width: 40%;\n}\n\n.focus-image-section img {\n    width: 100%;\n    border-radius: 16px;\n    object-fit: cover;\n    max-height: 300px;\n}\n\n/* Maklumat Aplikasi (Kanan) */\n.focus-details-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.focus-details-section h2 {\n    text-align: left;\n    color: #007bff;\n    margin: 0 0 5px 0;\n    font-size: 1.5rem;\n}\n\n.focus-version-tag {\n    font-size: 13px;\n    color: #a0a0a0;\n    margin: 0 0 15px 0;\n    text-align: left;\n}\n\n.focus-full-description {\n    font-size: 14px;\n    color: #ccc;\n    line-height: 1.6;\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n/* Kotak putih bahagian butang bawah */\n.focus-action-box {\n    background: #ffffff;\n    padding: 15px;\n    border-radius: 8px;\n    color: #333;\n    margin-top: auto;\n}\n\n.focus-download-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n\n.device-badge {\n    font-size: 14px;\n    color: #555;\n    font-weight: 500;\n}\n\n.device-badge span {\n    color: #007bff;\n    font-weight: bold;\n}\n\n/* Butang Muat Turun Utama Dalam Modal */\n.focus-action-download-btn {\n    display: inline-block;\n    background: #007bff;\n    color: #ffffff;\n    text-decoration: none;\n    padding: 10px 24px;\n    font-weight: bold;\n    border-radius: 6px;\n    text-align: center;\n    transition: background-color 0.2s;\n}\n\n.focus-action-download-btn:hover {\n    background-color: #6db2fd; /* Guna tema oren asal hover kau */\n}\n\n/* 📱 Responsive Inframe Modal Khusus Skrin Mobile 📱 */\n@media (max-width: 768px) {\n    .download-focus-inframe {\n        width: 100%;\n        padding: 20px;\n        margin: 10px;\n    }\n\n    /* Tukar susunan kiri-kanan kepada atas-bawah */\n    .focus-content-layout {\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    /* Gambar naik atas dan duduk tengah */\n    .focus-image-section {\n        max-width: 100%;\n        text-align: center;\n        margin: 0 auto;\n    }\n\n    .focus-image-section img {\n        max-height: 180px;\n        width: auto;\n        max-width: 100%;\n    }\n\n    /* Ratakan teks ke tengah supaya kemas kat fon */\n    .focus-details-section h2 {\n        font-size: 1.2rem;\n        text-align: center;\n    }\n\n    .focus-version-tag {\n        text-align: center;\n        margin-bottom: 10px;\n    }\n\n    .focus-full-description {\n        font-size: 13px;\n        text-align: center;\n        margin-bottom: 15px;\n    }\n    \n    /* Bar aksi bertukar menegak */\n    .focus-download-row {\n        flex-direction: column;\n        gap: 12px;\n        text-align: center;\n    }\n    \n    /* Butang download lebar penuh */\n    .focus-action-download-btn {\n        width: 100%;\n        box-sizing: border-box;\n    }\n}\n\n/* Animasi khusus naik modal (Tak bertembung dengan fadeIn asal) */\n@keyframes modalSlideUp {\n    from { transform: translateY(20px); opacity: 0; }\n    to { transform: translateY(0); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
